import React from 'react'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import { message } from 'antd'
import { autobind } from 'core-decorators'
import OrganizationApi from 'api/OrganizationApi'
import slug from 'constants/slug'
import OrganizationForm from '../organization-form'
import Breadcrumb from '../breadcrumb'

@autobind
export default class OrganizationCreate extends React.PureComponent {
  async handleSubmit(data) {
    const res = await OrganizationApi.create(data)
    if (res.success) {
      message.info('Create Organization success!')
      this.props.history.push(slug.organization.list)
    }
    if (res.error) message.info(res.message)
  }

  render() {
    return (
      <PageContainer title="Create Organization" {...this.props.wrapperProps}>
        <Breadcrumb items={['list', 'create']} />
        <OrganizationForm onSubmit={this.handleSubmit} />
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/organization/organization-create/index.js